import store from "../store";

export function setCurrentRole(currentRole:any){
    store.dispatch({
        type:"setCurrentRole",
        payload: currentRole
    })
}
export function setCurrentAppType(appType:any){
    store.dispatch({
        type:"setCurrentAppType",
        payload: appType
    })
}